/*
Point5FullIcon_Dark.js
点五的全展示icon,黑色
 */

import React from 'react';

export const Point5FullSVG = (props) => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 3956.000000 1138.000000"
         preserveAspectRatio="xMidYMid meet" {...props}>

        <g transform="translate(0.000000,1138.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">
            <path d="M2385 11366 c-92 -29 -139 -70 -177 -151 l-23 -50 0 -1415 0 -1415
28 -57 c46 -93 80 -115 302 -194 795 -283 1557 -872 2015 -1560 102 -153 152
-189 265 -188 67 0 76 3 200 67 224 114 449 193 682 236 314 60 678 56 993
-10 372 -77 752 -258 1060 -506 107 -85 286 -263 370 -367 167 -207 345 -523
425 -755 285 -828 131 -1728 -413 -2411 -161 -202 -406 -420 -637 -565 -294
-186 -669 -316 -1035 -361 -166 -20 -522 -15 -670 10 -361 61 -671 177 -958
357 -51 33 -95 59 -97 59 -2 0 -16 -21 -31 -48 -15 -26 -60 -98 -100 -160
l-74 -113 141 -137 c78 -75 178 -182 222 -237 251 -311 428 -675 513 -1053 31
-141 45 -177 87 -220 74 -77 155 -96 492 -112 1073 -50 2131 324 2940 1040
627 556 1074 1291 1279 2105 148 589 163 1208 45 1811 -287 1469 -1364 2685
-2792 3153 -752 246 -1549 273 -2327 76 -349 -88 -745 -252 -1064 -439 -71
-42 -133 -76 -138 -76 -5 0 -7 389 -6 883 l3 882 28 57 c31 64 70 101 137 132
45 21 50 21 1505 26 l1460 5 40 22 c58 31 95 74 168 198 187 317 467 601 785
798 164 102 395 207 575 263 l57 18 0 208 0 208 -3117 -1 c-2485 0 -3126 -3
-3158 -13z"/>
            <path d="M19835 6856 c-240 -60 -378 -303 -305 -539 50 -163 196 -277 375
-294 269 -25 500 221 457 485 -41 248 -284 408 -527 348z"/>
            <path d="M32090 6844 c-202 -54 -338 -264 -303 -468 41 -239 249 -389 489
-355 184 26 325 165 357 355 28 162 -57 341 -203 427 -93 54 -229 71 -340 41z"/>
            <path d="M12505 6689 c-38 -12 -68 -37 -94 -80 l-21 -34 0 -1930 c0 -1863 1
-1931 19 -1971 10 -23 36 -54 57 -70 l37 -29 306 -3 c168 -2 320 0 338 3 42 8
89 47 113 96 19 37 20 63 20 666 0 706 -2 680 76 739 l37 29 466 6 c415 5 478
8 581 27 616 113 982 436 1102 973 31 140 33 446 4 579 -84 384 -304 667 -650
836 -192 93 -382 143 -626 164 -146 12 -1724 12 -1765 -1z m1594 -709 c366
-38 570 -244 571 -578 1 -290 -147 -480 -431 -553 -77 -20 -115 -22 -438 -26
-194 -3 -369 -2 -388 2 -46 8 -110 68 -123 113 -6 23 -10 211 -10 480 0 476 1
482 52 530 14 13 38 27 54 32 41 12 593 12 713 0z"/>
            <path d="M28474 6689 c-47 -14 -101 -79 -109 -131 -3 -24 -5 -905 -3 -1958 3
-1911 3 -1915 24 -1950 11 -19 35 -45 54 -57 33 -23 37 -23 360 -23 323 0 327
0 360 23 19 12 43 38 54 57 21 34 21 51 26 755 5 700 6 721 25 747 11 14 34
35 50 45 28 17 78 18 867 23 825 5 837 5 864 26 15 11 37 33 48 48 20 26 21
40 21 291 0 251 -1 265 -21 291 -11 15 -33 37 -48 48 -27 21 -39 21 -865 26
l-838 5 -36 28 c-68 52 -67 43 -67 479 0 375 1 395 20 426 11 18 34 41 52 52
32 19 53 20 898 20 557 0 881 4 910 11 55 12 106 59 120 109 5 19 10 136 10
259 0 207 -2 228 -21 267 -12 26 -36 53 -57 66 l-37 23 -1315 2 c-771 1 -1328
-2 -1346 -8z"/>
            <path d="M24885 6496 c-16 -7 -39 -23 -50 -36 -19 -21 -20 -40 -25 -364 -5
-362 -6 -365 -56 -405 -24 -19 -40 -21 -171 -21 -164 0 -201 -10 -233 -62 -18
-31 -20 -50 -20 -263 0 -213 2 -232 20 -263 32 -52 70 -62 227 -62 153 0 175
-6 210 -59 l23 -34 0 -856 c0 -922 0 -919 53 -1051 42 -102 88 -171 172 -255
136 -135 307 -215 508 -237 112 -12 427 2 517 23 54 12 93 47 127 114 28 54
233 496 233 501 0 2 -123 3 -272 1 -271 -2 -273 -2 -333 23 -72 30 -118 85
-134 160 -7 34 -11 301 -11 816 0 687 2 769 16 793 32 53 42 56 287 61 l229 5
34 37 34 38 0 244 c0 337 10 326 -305 326 -165 0 -212 3 -235 15 -58 30 -60
42 -60 397 0 463 35 428 -430 428 -247 -1 -332 -4 -355 -14z"/>
            <path d="M22670 5733 c-308 -22 -495 -86 -608 -208 l-62 -66 0 44 c0 24 -3 72
-6 106 l-7 61 -374 0 c-411 0 -428 -2 -457 -59 -14 -27 -16 -184 -16 -1486 0
-1569 -2 -1501 51 -1539 21 -14 66 -16 377 -16 386 0 398 2 420 57 8 20 13
274 15 843 3 589 7 836 16 889 49 294 155 503 309 608 82 56 143 73 261 73
241 0 383 -104 452 -330 l23 -75 6 -1003 5 -1004 33 -29 32 -29 361 0 361 0
34 34 35 35 -3 1063 c-4 1183 -1 1138 -74 1357 -127 384 -386 608 -774 666
-85 13 -287 17 -410 8z"/>
            <path d="M17115 5694 c-327 -50 -636 -210 -875 -454 -471 -478 -582 -1198
-278 -1804 230 -458 665 -770 1181 -846 101 -15 333 -15 434 0 186 27 351 81
522 171 139 72 242 150 371 279 226 224 368 493 432 815 30 146 31 422 4 565
-42 219 -144 460 -269 637 -73 103 -234 268 -331 340 -211 156 -460 261 -710
298 -127 18 -358 18 -481 -1z m365 -744 c227 -36 430 -166 554 -354 107 -161
141 -287 134 -490 -4 -113 -9 -143 -35 -218 -90 -259 -296 -454 -560 -530
-112 -32 -314 -32 -426 0 -237 68 -436 240 -534 460 -60 137 -81 356 -48 502
97 417 501 695 915 630z"/>
            <path d="M37777 5669 c-265 -30 -529 -130 -744 -282 -113 -80 -301 -267 -382
-382 -72 -102 -168 -292 -206 -409 -68 -204 -95 -437 -76 -642 21 -231 64
-383 166 -589 230 -465 688 -793 1206 -865 131 -19 355 -14 489 9 418 72 780
301 1032 652 101 140 113 184 65 237 l-20 22 -379 0 c-417 0 -391 3 -488 -66
-69 -49 -186 -101 -282 -124 -100 -24 -280 -27 -380 -6 -255 55 -479 229 -599
468 -45 90 -48 120 -14 153 l24 25 1175 0 1174 0 6 28 c23 122 13 356 -24 523
-111 510 -477 946 -955 1138 -252 101 -532 140 -788 110z m326 -724 c177 -31
323 -105 454 -230 75 -72 83 -84 83 -117 0 -28 -6 -42 -26 -57 -26 -21 -34
-21 -656 -21 l-629 0 -24 25 c-42 41 -34 77 33 147 196 207 484 302 765 253z"/>
            <path d="M19649 5656 c-57 -20 -96 -53 -118 -99 -21 -43 -21 -44 -21 -1438 0
-1336 1 -1396 19 -1434 22 -47 64 -89 104 -104 18 -7 135 -11 308 -11 260 0
283 1 319 20 44 22 82 68 99 119 16 48 16 2758 0 2816 -15 52 -82 119 -134
134 -59 16 -529 14 -576 -3z"/>
            <path d="M31907 5655 c-50 -17 -85 -50 -108 -100 -18 -38 -19 -100 -19 -1438
0 -1235 2 -1402 15 -1434 20 -48 41 -71 87 -94 34 -17 62 -19 328 -19 266 0
294 2 328 19 46 23 67 46 87 94 13 32 15 199 15 1434 0 1335 -1 1400 -19 1438
-22 50 -69 91 -119 105 -58 16 -548 12 -595 -5z"/>
            <path d="M33190 5663 c-29 -11 -60 -47 -66 -77 -4 -25 102 -348 485 -1478 269
-796 495 -1456 500 -1467 6 -10 24 -31 42 -45 l31 -26 394 0 c417 0 424 1 466
47 16 17 1048 2923 1048 2951 0 27 -31 72 -60 87 -41 21 -603 22 -653 1 -60
-25 -73 -51 -167 -341 -202 -622 -494 -1491 -507 -1511 -33 -51 -119 -55 -163
-9 -16 17 -38 82 -77 222 -303 1097 -437 1572 -449 1591 -8 13 -29 32 -47 42
-30 19 -52 20 -397 19 -201 0 -372 -3 -380 -6z"/>
            <path d="M995 5239 c-217 -16 -436 -108 -609 -255 -473 -403 -511 -1124 -82
-1573 255 -266 611 -386 967 -325 301 52 561 221 728 475 291 442 223 1020
-164 1388 -226 214 -514 314 -840 290z"/>
            <path d="M6008 4970 c-253 -46 -465 -203 -584 -432 -66 -128 -87 -216 -87
-368 -1 -154 16 -226 85 -370 46 -95 61 -115 152 -205 84 -84 117 -109 193
-148 135 -69 220 -90 378 -91 151 -1 237 19 370 84 201 99 360 296 422 520 25
92 25 320 0 410 -76 280 -293 501 -569 581 -82 23 -279 34 -360 19z"/>
        </g>
    </svg>
);
